import React from 'react'
import { UserRole } from '@myapp/contract'
import { API_URL } from '../../../shared/config/axios'
import { getPositionsFromRoles } from '../lib/getPositionFromRole'

interface Props {
  technicianId: string
  technicianName: string | null
  technicianRoles: UserRole[]
  technicianAvatar: string | null
}

export const TechnicianInfo = ({ technicianId, technicianName, technicianRoles, technicianAvatar }: Props) => {
  const initials = (technicianName ?? technicianId).slice(0, 2).toUpperCase()
  const avatarUrl = technicianAvatar ? `${API_URL}/static/${technicianAvatar}` : null

  return (
    // No `sticky`, no `z-*`: where this cell sits and what it has to paint over belong to the board
    // that lays it out, not to the card. The disposition board wraps it in a sticky positioned box
    // (`BOARD_LAYER.technicianColumn`); an entity cannot import that scale without importing upwards.
    <div className="w-56 h-full shrink-0 self-stretch p-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-center gap-3.5">
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={technicianName ?? technicianId}
          className="w-11 h-11 rounded-full object-cover shrink-0"
        />
      ) : (
        <div className="w-11 h-11 rounded-full bg-blue-900 flex items-center justify-center text-white text-sm font-medium shrink-0">
          {initials}
        </div>
      )}
      <div className="flex-1 min-w-0 flex flex-col gap-0.5">
        <div className="text-slate-900 text-sm font-normal font-['Roboto'] leading-4 truncate">
          {technicianName ?? technicianId}
        </div>
        <div className="text-zinc-500 text-xs font-normal font-['Roboto'] leading-4 min-h-8">
          {getPositionsFromRoles(technicianRoles)}
        </div>
      </div>
    </div>
  )
}
